import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";

export const WrongBarcodeModal = memo(function WrongBarcodeModal({
  barcode,
  onClose,
}: {
  barcode: string;
  onClose: () => void;
}) {
  return (
    <RedoModal
      onModalCloseRequested={onClose}
      primaryButton={{ onClick: onClose, text: "Close" }}
      title="Wrong item"
    >
      Scanned item {barcode} should not be included in this shipment.
    </RedoModal>
  );
});
